(function(algolia) {
  'use strict';

  const getAlgoliaResults = algolia.externals.getAlgoliaResults;
  const { config, translations, headerTemplate, pagesTemplate } = algolia;

  algolia.pagesPlugin = {
    getSources({ query }) {
      return [
        {
          sourceId: 'pages',
          getItems() {
            return getAlgoliaResults({
              searchClient: algolia.searchClient,
              queries: [
                {
                  indexName: config.index_prefix + 'pages',
                  query,
                  params: {
                    hitsPerPage: config.pages_autocomplete_hits_per_page,
                    clickAnalytics: config.analytics_enabled
                  },
                },
              ],
            });
          },
          templates: {
            header({ html, state }) {
              return '';
              const resource = translations.pages;
              return headerTemplate({ html, state }, resource);
            },
            item({ item, html, components, state }) {
              const itemLink = `/pages/${item.handle}`;
              return pagesTemplate({ item, html, components, state }, itemLink);
            },
          },
        }
      ];
    },
  }
})(window.algoliaShopify);
